var cache = require("../models/cache"),
  configManager = require('../config/configManager'),
  CONST_ERROR = require('../constants/errors'),
  CONST_EVENTS = require('../constants/events'),
  formParser = require('../libraries/formParser'),
  jwtUtility = require("../utilities/jwtUtility"),
  GeneralError = require('../models/errors/generalError'),
  log = require("../libraries/logger").getLoggerInstance('Base.Events.SetupHandler'),
  messageRouter = require("../messages/messageRouter"),
  passiveEvents = require('../events/eventObserver').passive,
  queueUtility = require("../utilities/queueUtility");

var publicMethods = {
  processSetup: function (executionQueue, message, setupData) {
    if (!cache.setup.eventCompleted) {
      log.info("Setting up Cardinal.js.");

      // First we need to configure the instance than validate we have everything we need or the logger will not be available to receive error messages with configurations.
      configManager.mergeMerchantConfigs(executionQueue.configurationQueue)
        .then(function () {
          cache.message = message;
          cache.merchantJwt = setupData.jwt;
          cache.cardinalResponseJwt = setupData.cardinalResponseJwt;
          cache.orderObject = setupData.order;
          cache.urls.postMessageWhiteList = configManager.getSystemConfig().midas.postMessageDomains;

          jwtUtility.parseJwtForLogs(cache.merchantJwt);

          if (cache.message === undefined) {
            throw new GeneralError(CONST_ERROR.CONFIGURATION.NUMBER, 'Unable to detect a message type. Please pass a message argument into the setup function.');
          }

          if (cache.merchantJwt) {
            log.info('JWT Detected on Setup. Processing will continue using JWT with signature [' + cache.merchantJwt.split('.')[2] + "]");
          } else if (setupData.apiKey && setupData.apiId && setupData.orgUnitId) {
            cache.merchantJwt = jwtUtility.generateJwt(setupData.apiId, setupData.apiKey, setupData.orgUnitId, setupData.order);
            log.info('JWT Generated: ' + cache.merchantJwt);
            passiveEvents.publish(CONST_EVENTS.JWT_CREATED, cache.merchantJwt);
          } else {
            throw new GeneralError(CONST_ERROR.CONFIGURATION.NUMBER, "Unable to detect a Transaction Flow. Please pass a JWT or API Identifier to the setup function.");
          }

          return;
        })
        .then(queueUtility.ProcessPassiveQueue(executionQueue.onQueue))
        .then(formParser.parse)
        .then(messageRouter.route)
        .then(queueUtility.ProcessActiveQueue(executionQueue.startQueue));
    } else {
      log.debug("Cardinal.setup has already been run, echoing back previous response data.");
      passiveEvents.publish(CONST_EVENTS.SETUP_COMPLETE, {
        sessionId: cache.consumerSessionId,
        modules: cache.setup.modulesLoaded
      });
    }

  }
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./events/setupHandler.js
// module id = 110
// module chunks = 5